import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_VAT_REPORT } from '../../../constants/eInvoicePermissions';
import { VAT_REPORT_MODULE_KEY } from '../../settings/constants/roleModules';

export default function VATReportAccessLayout() {
  const title = useRoleModuleLabel(VAT_REPORT_MODULE_KEY);

  return <EInvoiceAccessLayout permission={READ_VAT_REPORT} title={title} />;
}
